import { render, staticRenderFns } from "./sysBoxItem.vue?vue&type=template&id=74b316c6&scoped=true&"
import script from "./sysBoxItem.vue?vue&type=script&lang=js&"
export * from "./sysBoxItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b316c6",
  null
  
)

export default component.exports